'use client';

import { useCallback } from 'react';
import useFlag from 'app/hooks/useFlag';
import { refreshToken } from './refreshToken';

/**
 * Wrapper around internal refreshToken function to be used in components.
 * Abstracts away the featureFlag call so components don't need to explicitly
 * retrieve the flag themeselves.
 *
 * Note: Not to be confused with the mutation useRefreshToken defined in app/users.
 * @returns
 */
export const useRefreshToken = () => {
  const auth0Enabled = useFlag('enableV2Auth0');

  return useCallback(
    async ({ entityId }: { entityId?: string } = {}) => {
      await refreshToken({ entityId, auth0Enabled });
    },
    [auth0Enabled]
  );
};
